
import { Avatar, Button, Card, Col, Form, Row, Tag, Typography } from 'antd';
import { replace } from 'connected-react-router';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormInput,
  FormCheckbox,
  FormButton,
  FormPassword,
} from "components/FormItems/FlatFormItems";
import { setLoading } from 'redux/actions/app.actions';
import { changePassword } from 'services/auth.services';
import { clearStorage } from 'utils/storage';
import { SafetyOutlined, UserOutlined } from '@ant-design/icons';
import { Button as RoundedButton } from "components/Buttons/Buttons";
import { push } from "connected-react-router";
import { getConfigByKey } from 'services/misc.service';
import Spinner from 'components/Spinner/Spinner';

const MaxWidth = 300
const KEY_ENABLED = 'IsTwoFactorEnabledGlobally'
const KEY_PREFERENCE = 'GlobalTwoFactorPreference'

export default function Profile() {
  const dispatch = useDispatch()
  const [form] = Form.useForm();
  const loggedUser = useSelector(state => state.user.currentUser)

  const [enabled, setEnabled] = useState(false) // boolean
  const [preference, setPreference] = useState(null) // Email = email, Phone = phone


  const [loadingEnabled, setLoadingEnabled] = useState(false)
  const [loadingPref, setLoadingPref] = useState(false)

  useEffect(() => {
    // load each config independently
    loadEnabled()
    loadPref()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadEnabled = async () => {
    setLoadingEnabled(true)
    try {
      const res = await dispatch(getConfigByKey(KEY_ENABLED, false))
      if (res?.status === 'success') {
        const val = res.data?.value
        // backend may store "true"/"false" or "1"/"0"
        const bool = val === 'true' || val === true || val === '1' || val === 1
        setEnabled(Boolean(bool))
      }
    } finally {
      setLoadingEnabled(false)
    }
  }

  const loadPref = async () => {
    setLoadingPref(true)
    try {
      const res = await dispatch(getConfigByKey(KEY_PREFERENCE, false))
      if (res?.status === 'success') {
        const val = res.data?.value
        setPreference(val ? val : null)
      }
    } finally {
      setLoadingPref(false)
    }
  }


  return (
    <div style={{
      padding: 16,
    }} className="settingsContainer">
      {/* <Card style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}>
        <div>
          <div style={{ display: 'flex', gap: 16 }}>
            <Avatar size={46} src={loggedUser?.profileImageUrl} icon={<UserOutlined />}
              style={{ minWidth: 46 }}
            />
            <div>
              <Typography.Title level={4} style={{ margin: 0 }}>{loggedUser?.userName}</Typography.Title>
              <Typography.Text style={{ color: '#666', fontSize: 15 }}>{loggedUser?.firstName} {loggedUser?.lastName}</Typography.Text>
            </div>
          </div>
        </div>
      </Card> */}
      <Card style={{ borderRadius: 8, boxShadow: '0px 5px 10px #dfe2e8' }}>
        <div>
          <div style={{ display: 'flex', gap: 16 }}>
            {/* <div size={46} icon={<SafetyOutlined style={{ color: '#16a34a'}} />}
              style={{ minWidth: 46, backgroundColor: 'rgb(34 197 94 / 0.1)' }}
            > */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 46, height: 46, backgroundColor: 'rgb(34 197 94 / 0.1)', borderRadius: 23 }}>
              <SafetyOutlined style={{ color: '#16a34a', fontSize: 20 }} />
            </div>
            <div>
              <Typography.Title level={4} style={{ margin: 0 }}>Two-Factor Authentication</Typography.Title>
              <Typography.Text style={{ color: '#666', fontSize: 15 }}>Account protection status</Typography.Text>
            </div>
          </div>
        </div>

        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, maxWidth: MaxWidth }}>
            <div>Status</div>
            {
              loadingEnabled ? <Spinner /> : enabled ? <Tag color="green" style={{ margin: 0 }}>Enabled</Tag> : <Tag color="yellow" style={{ margin: 0 }}>Disabled</Tag>
            }
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, maxWidth: MaxWidth }}>
            <div>Prefered Method</div>
            <div>{loadingPref ? <Spinner /> : preference ? preference : 'None'}</div>
          </div>
        </div>
        <div style={{ marginTop: 24, display: 'flex', maxWidth: MaxWidth, justifyContent: 'center' }}>
          <RoundedButton
            rounded
            onClick={() => dispatch(push("/dashboard/tfa"))}

          >
            Open
          </RoundedButton>
        </div>
      </Card>

    </div>
  )
}
